export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-time-line',
      title: 'Same-Day Service',
      description: 'Fast response and scheduling that works around your day. We prioritize same-day or next-day appointments whenever possible.',
      color: 'bg-[#FF6B4A]'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Professional Crews',
      description: 'Experienced, respectful, and insured teams. All our crew members are trained professionals who treat your property with care.',
      color: 'bg-[#FF6B4A]'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Transparent Pricing',
      description: 'No hidden fees; know your cost upfront. We provide clear, honest pricing based on truck size before we start any work.',
      color: 'bg-[#FF6B4A]'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly Disposal',
      description: 'We donate, recycle, and dispose responsibly. Your junk is sorted and processed in the most environmentally conscious way possible.',
      color: 'bg-[#FF6B4A]'
    }
  ];

  return (
    <section id="why-us" className="py-24 bg-[#F9FAFB] relative overflow-hidden">
      {/* Decorative Circle */}
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#FFF5F2] rounded-full opacity-50 -mr-48 -mb-48"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Section Title */}
        <div className="mb-16">
          <h2 className="text-5xl font-serif text-[#2C2C2C] mb-4">Why Charleston Trusts Us</h2>
          <div className="w-20 h-1 bg-[#FF6B4A]"></div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col">
              <div className="flex items-center gap-5 mb-4">
                {/* Icon Circle */}
                <div className={`${feature.color} rounded-full w-18 h-18 flex items-center justify-center flex-shrink-0`}>
                  <i className={`${feature.icon} text-white text-4xl`}></i>
                </div>
                {/* Title */}
                <h3 className="text-2xl font-bold text-[#2C2C2C]">{feature.title}</h3>
              </div>
              {/* Description */}
              <p className="text-[#6B7280] text-base leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 pt-12 border-t border-[#E5E7EB]">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#FF6B4A] mb-2">500+</div>
              <div className="text-sm text-[#6B7280]">Happy Customers</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#FF6B4A] mb-2">5★</div>
              <div className="text-sm text-[#6B7280]">Average Rating</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#FF6B4A] mb-2">Same Day</div>
              <div className="text-sm text-[#6B7280]">Service Available</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#FF6B4A] mb-2">100%</div>
              <div className="text-sm text-[#6B7280]">Satisfaction Guaranteed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
